import { render, staticRenderFns } from "./UploadsPhotos.vue?vue&type=template&id=b23cdff0&scoped=true"
import script from "./UploadsPhotos.vue?vue&type=script&lang=js"
export * from "./UploadsPhotos.vue?vue&type=script&lang=js"
import style0 from "./UploadsPhotos.vue?vue&type=style&index=0&id=b23cdff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23cdff0",
  null
  
)

export default component.exports